import { AutocompleteArrayInput, AutocompleteInput, ReferenceArrayInput, ReferenceInput } from 'react-admin';

import { MAX_NUMBER_OF_ENTITIES } from '@app/constants';
import { genericfilterToQuery } from '@app/utils/filterUtils';
import { DEFAULT_LANGUAGE } from '@app/utils/languages';
import { Box } from '@mui/material';
import _debounce from 'lodash/debounce';

export const ExpertsFilter = () => {
  return (
    <>
      <Box component="span" mr={2} sx={{ minWidth: '16vw' }}>
        <ReferenceInput
          source="companyId"
          reference="companies"
          perPage={MAX_NUMBER_OF_ENTITIES}
          sort={{ field: 'short_name', order: 'ASC' }}>
          <AutocompleteInput
            label="Company"
            variant="outlined"
            helperText={false}
            defaultValue={null}
            parse={(value) => {
              // Passing in null for companyId in the API removes the association
              if (value === '') {
                return null;
              }
              return value;
            }}
            fullWidth
            optionText={(record) => record.name[DEFAULT_LANGUAGE]}
            filterToQuery={genericfilterToQuery}
          />
        </ReferenceInput>
      </Box>
      <Box component="span" mr={2} sx={{ minWidth: '16vw' }}>
        <ReferenceArrayInput source="expertiseIds" reference="taxonomies" perPage={MAX_NUMBER_OF_ENTITIES}>
          <AutocompleteArrayInput
            variant="outlined"
            helperText={false}
            defaultValue={undefined}
            autoHighlight
            parse={(value) => {
              // Passing in null for expertiseId in the API removes the association
              if (value === '') {
                return null;
              }
              return value;
            }}
            label="Expertise"
            filterToQuery={genericfilterToQuery}
            fullWidth
            optionText={(record) => (record?.category_name ? record?.category_name[DEFAULT_LANGUAGE] : '')}
          />
        </ReferenceArrayInput>
      </Box>
    </>
  );
};
